import React, { useContext, useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Grid } from "@mui/material";
import { Link, useLocation, useParams } from "react-router-dom";

import { DEFAULT_REGION_CODE } from "../constants/index";
import { IdentityContext } from "../context/identity-context";
import {
  GetIdentityByIdentityIDParams,
  getIdentityByIdentityID,
} from "api/endpoints/identity";
import { callOptionsHeaders } from "api/helpers";
import IdentityDetails from "components/identity-display/identity-details";
import IdentityUsersTab from "components/identity-display/identity-users-tab";
import { SnackbarContext } from "context/snackbar-context";
import { IdentityUrlParamTypes } from "types/identity";

type LocationState = {
  userID: string;
  userRegion: string;
};

const Identity = () => {
  const { identityId } = useParams<IdentityUrlParamTypes>();
  const location = useLocation<LocationState>();
  const { userID } = location.state || { userID: "" };
  const { userRegion } = location.state || { userRegion: "" };

  const { setIdentity } = useContext(IdentityContext);
  const { showError } = useContext(SnackbarContext);

  const [isLoadingIdentity, setIsLoadingIdentity] = useState<boolean>(false);

  const getIdentity = async () => {
    setIsLoadingIdentity(true);

    const getIdentityPayload: GetIdentityByIdentityIDParams = {
      identityId: identityId,
    };

    await getIdentityByIdentityID(
      getIdentityPayload,
      callOptionsHeaders(DEFAULT_REGION_CODE, identityId),
    )
      .then((resp) => {
        if (resp.identity) {
          setIdentity(resp.identity);
        }
      })
      .catch(showError)
      .finally(() => {
        setIsLoadingIdentity(false);
      });
  };

  useEffect(() => {
    getIdentity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identityId]);

  return (
    <Grid container>
      <Link
        to={
          userID && userRegion
            ? `/user/${userRegion}/${userID}`
            : "/search/identity"
        }
        className="remove-link-style"
        style={{ position: "relative", bottom: "5px" }}
        data-testid="identity-back-link"
      >
        <Button
          startIcon={<ArrowBackIcon />}
          color="primary"
          data-anchor="identity-back-btn"
          data-testid="identity-back-btn"
        >
          Back
        </Button>
      </Link>
      <Grid container spacing={3}>
        <IdentityDetails isLoadingIdentity={isLoadingIdentity} />
        <Grid item xs={12} lg={12}>
          <IdentityUsersTab />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Identity;
